import type { ItemList } from '@/shared/types';

type ItemData = Record<string, unknown>;

type Item = string | null;
type IdItem = Item;
type ValueItem = Item;

export default (
	data: Array<ItemData>,
	keys: [IdItem, ValueItem],
	disableCb?: () => boolean,
): Array<ItemList> => {
	const [idKey, valueKey] = keys;

	return data.map((item: ItemData) => {
		const record: any = {};

		if (idKey !== null) {
			record.id = item[idKey];
		}

		if (valueKey !== null) {
			record.value = item[valueKey];
		}

		if (disableCb) {
			record.disabled = disableCb();
		}

		return record;
	});
};
